import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { PropsWithChildren, useEffect } from 'react';
import firebase from 'gatsby-plugin-firebase';
import SEO from 'components/SEO';
import theme from './theme';

export const App = ({ children }: PropsWithChildren<unknown>) => {
  useEffect(() => {
    firebase.analytics();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default App;
